import { useRef, useEffect, useState } from 'react'
import Head from 'next/head'
import Link from 'next/link'
import { Footer, Intro, Work, Feature, Header, Hero } from 'components/pages/index'
import PropTypes from 'prop-types'
import { withTranslation } from 'i18n'
import { useRouter } from "next/router"
import appConfig from 'config'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import nextI18NextConfig from '../../i18n'

const Dating = (props) => {
  const { t } = useTranslation('dating')
  const router = useRouter()
  return (
    <div className='container-home' id='dating'>
      <Head>
        <title>{t('title')}</title>
        {/* SEO page */}
        <meta name='description' content={t('description')} />
        <meta property='og:url' content={ appConfig.URL + router.route } />
        <meta property='og:title' content={t('title')} />
        <meta property='og:image' content={ appConfig.URL + '/images/hero_1.png' } />
        <meta property='og:description' content={t('description')} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Flirtbees" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={t('title')} />
        <meta name="twitter:description" content={t('description')} />
        <meta name="twitter:image" content={ appConfig.URL + '/images/hero_1.png' } />
        <meta name="twitter:url" content={ appConfig.URL + router.route } />
      </Head>
      <Hero t={t} />
      <Intro t={t} />
      <Work t={t} />
      <Feature t={t} />
      <Footer t={t} />
    </div>
  )
}

export async function getServerSideProps({locale}) {
  return {
    props: {
      ...(await serverSideTranslations(locale , ['dating'], nextI18NextConfig))
    }
  }
}

export default Dating
